export type SiteAnalyticsKey =
  'codelogician' | 'speclogician' | 'imandrax' | 'ipl' | 'imandra' | 'universe'

/**
 * StatCounter IDs by hostname — source of truth for GTM dedupe and for
 * properties that do not mount {@link SITE_ANALYTICS} via the React
 * `SiteAnalytics` component (docs; universe injects the same IDs from Helm).
 */
export const STATCOUNTER_REFERENCE = {
  'imandra.ai': { project: 11040106, security: '6223f990' },
  'universe.imandra.ai': { project: 13082942, security: '737ffd4d' },
  'docs.imandra.ai': { project: 11767520, security: 'fa7e88d1' },
} as const

/** Shared LinkedIn Insight Tag partner ID (Imandra ad account). */
export const LINKEDIN_PARTNER_ID = '8794908'

export type SiteAnalyticsConfig = {
  gtm?: { containerId: string }
  statcounter?: { project: number; security: string }
  linkedIn?: { partnerId: string }
  ga?: { measurementId: string }
}

export const SITE_ANALYTICS: Record<SiteAnalyticsKey, SiteAnalyticsConfig> = {
  codelogician: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 13187587, security: 'd07ac834' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
  speclogician: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 13289149, security: '47fd8a3a' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
  imandrax: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 13209904, security: '6f24db03' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
  ipl: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 13269444, security: '80c3035b' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
  imandra: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 11040106, security: '6223f990' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
  universe: {
    gtm: { containerId: 'GTM-NWBNRSQ6' },
    statcounter: { project: 13082942, security: '737ffd4d' },
    linkedIn: { partnerId: LINKEDIN_PARTNER_ID },
  },
}
